'use strict';

/**
 * @name travel
 */

// 选择城市
exports.selectCity = require('./select-city.js');

// 设置客户端大G埋点
exports.setGdata = require('./set-g-data.js');

// 获取pos机id
exports.getPosDeviceId = require('./biz-pos-device-id.js');

// 获取pos机打印状态
exports.printerState = require('./biz-pos-printer.js');

// 打印
exports.print = require('./biz-pos-print.js');


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/travel/index.js
// module id = 644
// module chunks = 0